export const OTHER_OPTIONS = [
  "Accessible",
  "Child Friendly",
  "Alcohol is Allowed"
]
export const LANGUAGES = [
  "English",
  "Spanish"
]
export const SKILL_LEVELS = [
  "Beginner",
  "Intermediate",
  "Advanced",
  "Professional"
]
